/* eslint-disable import/no-cycle */
import { logger } from './logger';
import {
  getCityAndCounty,
  getShop,
  getUTMData,
  isArrowInstalled,
} from './pageData';
import { goToCartUtils } from '../index-utils';

export function goToCart({ isPopup, isRefreshPageAfterProductAddition }) {
  return goToCartUtils({ isPopup, isRefreshPageAfterProductAddition });
}

export function goToCheckout({ discountCodes, isStorefrontCart }) {
  if (isStorefrontCart) {
    logger.log('storefront');
  }

  const queryParams = {};

  // convert discountCodes array into a query parameter called discount
  if (discountCodes && discountCodes.length > 0) {
    queryParams.discount = discountCodes.join(',');
  }

  const { city, county } = getCityAndCounty();
  if (city) {
    queryParams['checkout[shipping_address][city]'] = city;
  }

  if (county) {
    queryParams['checkout[shipping_address][address2]'] = county;
  }

  const query = new URLSearchParams(queryParams).toString();
  let location = '/checkout';
  if (query) {
    location = `/checkout?${query}`;
  }
  logger.log('go to checkout', location);
  window.location = location;
}

export function goToProductPage(handle) {
  logger.log('go to product');
  window.location = `/products/${handle}`;
  return true;
}

export function goToDraftOrderCheckout(orderURL) {
  const url = new window.URL(orderURL);
  if (['stickit-up.myshopify.com'].includes(getShop())) {
    const data = getUTMData();
    Object.keys(data).map(key => url.searchParams.set(key, data[key]));
  }

  if (['borngood.myshopify.com'].includes(getShop())) {
    if (window.Shopflo && window.Shopflo.openFloCheckout) {
      window.Shopflo.openFloCheckout(orderURL);
      return;
    }
  }

  window.location = url;
}

export function goToDiscountedCheckout(data, discountCodes) {
  const { order_url, isCustomCheckout } = data;
  logger.log('go to discounted checkout', order_url, isCustomCheckout);
  if (!isCustomCheckout) {
    if (order_url) {
      goToDraftOrderCheckout(order_url);
      return;
    }

    goToCheckout({ discountCodes });
    return;
  }

  const { cartJS } = data;
  document.documentElement.dispatchEvent(
    new CustomEvent('monk:customCheckout', {
      bubbles: true,
      detail: {
        cartJS,
      },
    }),
  );

  if (isArrowInstalled()) {
    const { total_discount } = cartJS;
    sessionStorage.setItem('mrArrowTotal', total_discount);
    window.arrow_checkout_clicked();
  }
}
